import React from 'react'
import WorkOrder from '../components/production/workorder/WorkOrder'

export default function WorkOrderPage() {
  return (
    <div><WorkOrder /></div>
  )
}
